import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const saveSSOConfig = api(async function saveSSOConfig(config) {
    return await mutate(
        gql`
            mutation saveSSOConfig(
                $clientId: String
                $enabled: Boolean
                $scimEnabled: Boolean
                $providerName: String
                $ssoLoginUrl: String
                $idpCertificate: String
                $spEntityId: String
                $emailDomains: [String]
                $emailAttribute: String
                $displayNameAttribute: String
                $wantAssertionsSigned: Boolean
                $wantAuthnResponseSigned: Boolean
                $enforceSSO: Boolean
            ) {
                saveSSOConfig(
                    clientId: $clientId
                    enabled: $enabled
                    scimEnabled: $scimEnabled
                    providerName: $providerName
                    ssoLoginUrl: $ssoLoginUrl
                    idpCertificate: $idpCertificate
                    spEntityId: $spEntityId
                    emailDomains: $emailDomains
                    emailAttribute: $emailAttribute
                    displayNameAttribute: $displayNameAttribute
                    wantAssertionsSigned: $wantAssertionsSigned
                    wantAuthnResponseSigned: $wantAuthnResponseSigned
                    enforceSSO: $enforceSSO
                ) {
                    _id
                    enabled
                    providerName
                }
            }
        `,
        config,
        { returns: "saveSSOConfig" }
    )
})

export const deleteSSOConfig = api(async function deleteSSOConfig({ clientId } = {}) {
    return await mutate(
        gql`
            mutation deleteSSOConfig($clientId: String) {
                deleteSSOConfig(clientId: $clientId)
            }
        `,
        { clientId },
        { returns: "deleteSSOConfig" }
    )
})
